<template>
  <div>
    <v-snackbar
      class="mt-5"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
  name: 'EmailVerification',
  data: () => ({
    color: '',
    alert: false,
    message: ''
  }),
  created () {
    this.$store.dispatch('ACTION_VERIFY_EMAIL_FOR_FORGOT_PASSWORD', this.$route.query).then((res) => {
      if (!res.success) {
        this.color = 'error'
        this.message = res.error.message || 'Something went wrong.'
        this.alert = true
        setTimeout(() => {
          this.$router.push('/')
        }, 3000)
      } else {
        VueCookie.set('userData', JSON.stringify(res.result))
        this.$router.push('/resetPassword')
      }
    })
  }
  // methods: {
  //   resendVerificationLink () {
  //     this.$store.dispatch('ACTION_RESEND_EMAIL', this.errorMeta).then((res) => {
  //       if (!res.success) {
  //         this.color = 'error'
  //         this.message = res.error.message || 'Something went wrong.'
  //         this.alert = true
  //       } else {
  //         this.color = 'success'
  //         this.message = 'Verification email sent, Please check your inbox.'
  //         this.alert = true
  //         this.remainingAttempts = res.result.metaData ? res.result.metaData.remainingAttempts : undefined
  //         if (this.remainingAttempts !== undefined) {
  //           this.remaining = true
  //         }
  //       }
  //     })
  //   }
  // }
}
</script>

<style>
.verification-link {
  margin-top: 20vh
}
</style>
